import { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { Icon, Button, Modal } from '@driftt/tide-core-legacy'
import cx from 'classnames'
import { withRouter, Link } from 'react-router'
import { makeHasGate } from 'app/modules/gates/selectors'
import { killOneTimeEmailSends } from 'app/modules/gates/selectors'
import { isOneTimeEmailPlaybook, NEW_EDITOR_PLAYBOOK_TYPES, isNonLandingPageBotPlaybook, isLandingPagePlaybook } from 'app/modules/playbook/constants'
import { getPlaybookEditorLink } from 'app/modules/playbook/selectors'

/* TODO: don't use these components */
import UIDropdown from 'shared-web/src/components/UIDropdown'
import UIDropdownItem from 'shared-web/src/components/UIDropdownItem'
import LoadingDots from 'components/shared/LoadingDots'
import IconSVG from 'svg-inline-react'
import trashIconSrc from '!svg-inline!images/svg/trash-red.svg'
import cloneIconSrc from '!svg-inline!images/svg/clone-icon.svg'
import editIconSrc from '!svg-inline!images/svg/edit-icon.svg'
import archiveIconSrc from '!svg-inline!images/svg/archive-icon.svg'
import unArchiveIconSrc from '!svg-inline!images/svg/unarchive-icon.svg'
/* END TODO */

import './editModal.styl'

const OLD_EMAIL_PLAYBOOK_TYPES = [
  'SEND_AN_AUTOMATED_EMAIL',
  'SEND_A_ONETIME_EMAIL',
]

const CloneDropdownItem = ({isOldEmailPlaybook, isCloneLoading, dropdownStyle, itemName = 'Clone'}) => {
  if (isOldEmailPlaybook) {
    return <UnableToCloneWarning style={dropdownStyle}/>
  }

  return (
    <div className="flex clone-link">
      {!isCloneLoading &&
        <div className="flex">
          <IconSVG src={cloneIconSrc} style={dropdownStyle} />{itemName}
        </div>
      }
      {isCloneLoading &&
        <span className="playbook-table-dropdown-loader">
          <LoadingDots />
        </span>
      }
    </div>
  )
}

const EditDropdownItem = withRouter(({ isNewType, url, style }) => (
  <Link className="playbook-table-option-edit" to={!isNewType && url} href={isNewType && url}>
    <div className="flex">
      <IconSVG src={editIconSrc} style={style}/>
      Edit
    </div>
  </Link>
))

const UnableToCloneWarning = ({style}) => (
  <div className="flex clone-link clone-link-disabled">
    <div is tooltip="This playbook type is no longer supported and cannot be cloned">
      <div className="flex">
        <IconSVG src={cloneIconSrc} style={style} />Clone
      </div>
    </div>
  </div>
)

const hasBotSegment = (playbook) => {
  return playbook && playbook.playbook && playbook.playbook.meta && playbook.playbook.meta.containsBotGeneratedSegment
}

const FANCY_REPORT_TYPES = [
  'MARKETING_SEQUENCE',
  'MARKETING_ONE_TIME_SEQUENCE',
  'BLOG_NURTURE',
  'NEW_BLOG_CONTENT',
  'NEWSLETTER',
  'PRODUCT_ANNOUNCEMENT',
  'OUTBOUND_SEQUENCE',
  'SIGNATURE',
]

class PlaybookEditCell extends Component {
  constructor(props) {
    super(props)

    const {
      playbookData: { playbook },
      playbookReportTypePlans,
    } = props

    this.state = {
      isOpen: false,
      modalOpen: false
    }
    this.dropdownIconStyle = { marginRight: '8px', width: '13px' }
    this.htmlBase = document.getElementsByTagName('html')[0]
    this.isArchived = playbook.status === 'ARCHIVED'
    this.isUpgradeLocked = this.isArchived && !playbookReportTypePlans.get(playbook.reportType)
    this.isOldEmailPlaybook = OLD_EMAIL_PLAYBOOK_TYPES.includes(playbook.reportType)
    this.isOneTimeEmailPlaybook = isOneTimeEmailPlaybook(playbook.reportType)
  }

  componentWillReceiveProps(nextProps) {
    const {
      playbook,
    } = nextProps.playbookData

    this.isCloneLoading = nextProps.getIsActionLoading(playbook.id, 'CLONE')
    this.isDeleteLoading = nextProps.getIsActionLoading(playbook.id, 'DELETE')
    this.isArchiveLoading = nextProps.getIsActionLoading(playbook.id, 'ARCHIVE')
    this.isUnArchiveLoading = nextProps.getIsActionLoading(playbook.id, 'UNARCHIVE')
    this.isArchived = playbook.status === 'ARCHIVED'
    this.isUpgradeLocked = this.isArchived && !nextProps.playbookReportTypePlans.get(playbook.reportType)
    this.isOldEmailPlaybook = OLD_EMAIL_PLAYBOOK_TYPES.includes(playbook.reportType)
    this.isOneTimeEmailPlaybook = isOneTimeEmailPlaybook(playbook.reportType)
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside, true)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true)
  }

  toggleModal = () => {
    this.setState(prevState => ({
      modalOpen: !prevState.modalOpen
    }))
  }

  handleClickOutside = (e) => {
    try {
      const node = ReactDOM.findDOMNode(this)
      if (node && !node.contains(e.target)) {
        this.setState({ isOpen: false })
      }
    } catch(error) {
      console.warn(error)
    }
  }

  onCloneAsLandingPageClick = () => {
    const {
      onDropdownActionClick,
      playbookData: { playbook }
    } = this.props
    onDropdownActionClick(playbook, 'CLONE_AS_LANDING_PAGE')
    this.setState({
      isOpen: false
    })
    this.htmlBase.click()
  }

  onCloneAsBotPlaybookClick = () => {
    const {
      onDropdownActionClick,
      playbookData: { playbook }
    } = this.props
    onDropdownActionClick(playbook, 'CLONE_AS_BOT_PLAYBOOK')
    this.setState({
      isOpen: false
    })
    this.htmlBase.click()
  }

  onCloneClick = () => {
    const {
      onDropdownActionClick,
      playbookData: { playbook }
    } = this.props
    onDropdownActionClick(playbook, 'CLONE')
    this.setState({
      isOpen: false
    })
    this.htmlBase.click()
  }

  onDeleteClick = () => {
    const {
      onDropdownActionClick,
      playbookData: { playbook }
    } = this.props
    onDropdownActionClick(playbook, 'DELETE')
    this.setState({ isOpen: false }, this.toggleModal)
    this.htmlBase.click()
  }

  onArchiveClick = () => {
    const {
      onDropdownActionClick,
      playbookData: { playbook }
    } = this.props
    onDropdownActionClick(playbook, 'ARCHIVE')
    this.setState({
      isOpen: false
    })
    this.htmlBase.click()
  }

  onUnArchiveClick = () => {
    const {
      onDropdownActionClick,
      playbookData: { playbook },
      router
    } = this.props

    if (this.isUpgradeLocked) {
      router.push('/settings/billing')
    } else {
      onDropdownActionClick(playbook, 'UNARCHIVE')
      this.setState({
        isOpen: false
      })
      this.htmlBase.click()
    }
  }

  linkToReport = (playbook) => {
    const isDraftEmailPlaybook = playbook.status === 'DISABLED' &&
    (playbook.reportType === 'SEND_A_ONETIME_EMAIL' || playbook.reportType === 'SEND_A_ONETIME_OUTBOUND_EMAIL')
    const isOldEmailPlaybook = OLD_EMAIL_PLAYBOOK_TYPES.includes(playbook.reportType)
    // outbound sequences need old report, draft playbooks should go right to edit because they haven't been seen yet
    return (
      isDraftEmailPlaybook ? `/playbooks/${playbook.id}/edit` : isOldEmailPlaybook ? `/reports/playbooks/${playbook.id}` : `/reports/chat-playbooks/${playbook.id}`
    )
  }

  externalReportLink = (playbook) => (`/reports/playbooks/${playbook.id}`)

  render() {
    const {
      isOpen,
      modalOpen
    } = this.state
    const {
      killOneTimeEmailSends,
      playbookEditorLink,
      playbookData,
      onEditPlaybookTriggered
    } = this.props

    const isNewType = NEW_EDITOR_PLAYBOOK_TYPES.includes(playbookData.playbook.reportType)
    const isSignaturePlaybook = playbookData.playbook.reportType === 'SIGNATURE'
    const isUsedInBotPlaybook = hasBotSegment(playbookData)
    const hasFancyReport = FANCY_REPORT_TYPES.includes(playbookData.playbook.reportType)
    const isOutboundChatPlaybook = playbookData.playbook.reportType === 'TALK_TO_YOUR_OUTBOUND_PROSPECTS'
    const isScheduledPlaybook = playbookData.playbook.status === 'SCHEDULED'
    const isBotPlaybook = isNonLandingPageBotPlaybook(playbookData.playbook.reportType)
    const landingPagePlaybook = isLandingPagePlaybook(playbookData.playbook.reportType)

    const OnlyEditDropdown = (
      <div>
        {!this.isArchived &&
            <UIDropdownItem onClick={() => onEditPlaybookTriggered(playbookData.playbook)}>
              <EditDropdownItem isNewType={isNewType} url={playbookEditorLink} style={this.dropdownIconStyle}/>
            </UIDropdownItem>
        }
        {!this.isArchived &&
          <UIDropdownItem onClick={!this.isArchiveLoading && this.onArchiveClick}>
            {!this.isArchiveLoading &&
              <div className="flex">
                <IconSVG src={archiveIconSrc} style={this.dropdownIconStyle} />
                Archive
              </div>
            }
            {this.isArchiveLoading &&
              <span className="playbook-table-dropdown-loader">
                <LoadingDots />
              </span>
            }
          </UIDropdownItem>
        }
        {this.isArchived &&
          <UIDropdownItem onClick={!this.isUnArchiveLoading && this.onUnArchiveClick}>
            {!this.isUnArchiveLoading && !this.isUpgradeLocked &&
              <div className="flex">
                <IconSVG src={unArchiveIconSrc} style={this.dropdownIconStyle} />
                Unarchive
              </div>
            }
            {this.isUpgradeLocked &&
              <div className="flex">
                <IconSVG src={unArchiveIconSrc} style={this.dropdownIconStyle} />
                Upgrade to Unarchive
              </div>
            }
            {this.isUnArchiveLoading &&
              <span className="playbook-table-dropdown-loader">
                <LoadingDots />
              </span>
            }
          </UIDropdownItem>
        }
        <UIDropdownItem onClick={!this.isDeleteLoading && this.toggleModal}>
          {!this.isDeleteLoading &&
            <div className="flex">
              <IconSVG src={trashIconSrc} style={this.dropdownIconStyle} />
              <span className="color-red">Delete</span>
            </div>
          }
          {this.isDeleteLoading &&
            <span className="playbook-table-dropdown-loader">
              <LoadingDots />
            </span>
          }
        </UIDropdownItem>
        {!this.isArchived && (
          <div className="playbook-table-option-disabled-copy">
            <p>Cloning is disabled for this playbook type.</p>
            <a href="https://help.drift.com/article/setting-up-the-outbound-playbook/" target="_blank">Learn more</a>
          </div>
        )}
      </div>
    )

    const ScheduledPlaybookDropdown = (
      <div>
        <UIDropdownItem onClick={(!this.isCloneLoading && !this.isOldEmailPlaybook) && this.onCloneClick}>
          <CloneDropdownItem isCloneLoading={this.isCloneLoading}
            isOldEmailPlaybook={this.isOldEmailPlaybook}
            dropdownStyle={this.dropdownIconStyle}
          />
        </UIDropdownItem>
        { isBotPlaybook &&
          <UIDropdownItem onClick={(!this.isCloneLoading && !this.isOldEmailPlaybook) && this.onCloneAsLandingPageClick}>
            <CloneDropdownItem isCloneLoading={this.isCloneLoading}
              isOldEmailPlaybook={this.isOldEmailPlaybook}
              dropdownStyle={this.dropdownIconStyle}
              itemName="Clone as Landing Page"
            />
          </UIDropdownItem>
        }
        { landingPagePlaybook &&
          <UIDropdownItem onClick={(!this.isCloneLoading && !this.isOldEmailPlaybook) && this.onCloneAsBotPlaybookClick}>
            <CloneDropdownItem isCloneLoading={this.isCloneLoading}
              isOldEmailPlaybook={this.isOldEmailPlaybook}
              dropdownStyle={this.dropdownIconStyle}
              itemName="Clone as Bot"
            />
          </UIDropdownItem>
        }
        <UIDropdownItem onClick={!this.isArchiveLoading && this.onArchiveClick}>
          {!this.isArchiveLoading &&
            <div className="flex">
              <IconSVG src={archiveIconSrc} style={this.dropdownIconStyle} />
              Archive
            </div>
          }
          {this.isArchiveLoading &&
            <span className="playbook-table-dropdown-loader">
              <LoadingDots />
            </span>
          }
        </UIDropdownItem>
        <UIDropdownItem onClick={!this.isDeleteLoading && this.toggleModal}>
            {!this.isDeleteLoading &&
              <div className="flex">
                <IconSVG src={trashIconSrc} style={this.dropdownIconStyle} />
                <span className="color-red">Delete</span>
              </div>
            }
            {this.isDeleteLoading &&
              <span className="playbook-table-dropdown-loader">
                <LoadingDots />
              </span>
            }
        </UIDropdownItem>
        <div className="playbook-table-scheduled-playbook-copy">
          <p> Editing is disabled for scheduled emails. Archive or delete it to stop from sending.</p>
        </div>
      </div>
    )


    const DefaultDropdownItems = (
      <div>
        {!this.isArchived &&
          <UIDropdownItem onClick={() => onEditPlaybookTriggered(playbookData.playbook)}>
            <EditDropdownItem isNewType={isNewType} url={playbookEditorLink} style={this.dropdownIconStyle}/>
          </UIDropdownItem>
        }
        {(!this.isArchived && !isSignaturePlaybook) && !(this.isOneTimeEmailPlaybook && killOneTimeEmailSends) &&
          <UIDropdownItem onClick={(!this.isCloneLoading && !this.isOldEmailPlaybook) && this.onCloneClick}>
            <CloneDropdownItem isCloneLoading={this.isCloneLoading}
              isOldEmailPlaybook={this.isOldEmailPlaybook}
              dropdownStyle={this.dropdownIconStyle}
            />
          </UIDropdownItem>
        }
        {(!this.isArchived && !isSignaturePlaybook) && !(this.isOneTimeEmailPlaybook && killOneTimeEmailSends) && isBotPlaybook &&
          <UIDropdownItem onClick={(!this.isCloneLoading && !this.isOldEmailPlaybook) && this.onCloneAsLandingPageClick}>
            <CloneDropdownItem isCloneLoading={this.isCloneLoading}
              isOldEmailPlaybook={this.isOldEmailPlaybook}
              dropdownStyle={this.dropdownIconStyle}
              itemName='Clone as Landing Page'
            />
          </UIDropdownItem>
        }
        {(!this.isArchived && !isSignaturePlaybook) && !(this.isOneTimeEmailPlaybook && killOneTimeEmailSends) && landingPagePlaybook &&
          <UIDropdownItem onClick={(!this.isCloneLoading && !this.isOldEmailPlaybook) && this.onCloneAsBotPlaybookClick}>
            <CloneDropdownItem isCloneLoading={this.isCloneLoading}
              isOldEmailPlaybook={this.isOldEmailPlaybook}
              dropdownStyle={this.dropdownIconStyle}
              itemName='Clone as Bot'
            />
          </UIDropdownItem>
        }
        {this.isArchived &&
          <UIDropdownItem onClick={!this.isUnArchiveLoading && this.onUnArchiveClick}>
            {!this.isUnArchiveLoading && !this.isUpgradeLocked &&
              <div className="flex">
                <IconSVG src={unArchiveIconSrc} style={this.dropdownIconStyle} />
                Unarchive
              </div>
            }
            {this.isUpgradeLocked &&
              <div className="flex">
                <IconSVG src={unArchiveIconSrc} style={this.dropdownIconStyle} />
                Upgrade to Unarchive
              </div>
            }
            {this.isUnArchiveLoading &&
              <span className="playbook-table-dropdown-loader">
                <LoadingDots />
              </span>
            }
          </UIDropdownItem>
        }
        {!this.isArchived &&
          <UIDropdownItem onClick={!this.isArchiveLoading && this.onArchiveClick}>
            {!this.isArchiveLoading &&
              <div className="flex">
                <IconSVG src={archiveIconSrc} style={this.dropdownIconStyle} />
                Archive
              </div>
            }
            {this.isArchiveLoading &&
              <span className="playbook-table-dropdown-loader">
                <LoadingDots />
              </span>
            }
          </UIDropdownItem>
        }
        <UIDropdownItem onClick={!this.isDeleteLoading && this.toggleModal}>
            {!this.isDeleteLoading &&
              <div className="flex">
                <IconSVG src={trashIconSrc} style={this.dropdownIconStyle} />
                <span className="color-red">Delete</span>
              </div>
            }
            {this.isDeleteLoading &&
              <span className="playbook-table-dropdown-loader">
                <LoadingDots />
              </span>
            }
        </UIDropdownItem>
      </div>
    )

    return (
      <div className="playbook-table-list-options-wrapper">
        {modalOpen &&
          <Modal
            open={modalOpen}
            type="warning"
            size="small"
            onClose={this.toggleModal}
            className="delete-playbook-modal"
          >
            <div className="delete-playbook-modal-body">
              <h2>
                  Delete <strong>{this.props.playbookData.playbook.name}</strong>?
              </h2>
              <p>
                {isUsedInBotPlaybook && <p>{this.props.playbookData.playbook.name} is currently being used in a bot playbook. The bot will no longer be able to enroll prospects in this email playbook.</p>}
                Are you sure you want to delete this playbook? You will not be able to recover your data after it has been deleted.
              </p>
            </div>
            <footer>
              <Button type="secondary" onClick={this.onDeleteClick}>Delete</Button>
              <Button type="tertiary" onClick={this.toggleModal}>Cancel</Button>
            </footer>
          </Modal>
        }
        {playbookData.playbook.reportType !== 'SIGNATURE' &&
          <Button href={hasFancyReport ? this.externalReportLink(playbookData.playbook) : this.linkToReport(playbookData.playbook)} type="tertiary" size="small" className="playbook-table-list-options-view-report-button">Report</Button>
        }
        <UIDropdown
          title={
            <Button
              type="tertiary"
              size="small"
              onClick={() => this.setState({ isOpen: true })}
              className={cx("playbook-table-list-options-dropdown", { 'playbook-table-list-options-dropdown-open': isOpen })}>
              <Icon name="settings-1" width="20" />
              <Icon name="chevron-down" width="7" />
            </Button>
          }
          attachment={isScheduledPlaybook ? "bottom right" : "top right"}
          targetAttachment={isScheduledPlaybook ? "top right" : "bottom right"}
          offset="8px 0px"
        >
          {(isOutboundChatPlaybook && OnlyEditDropdown) ||
            (isScheduledPlaybook && ScheduledPlaybookDropdown) ||
          DefaultDropdownItems}
        </UIDropdown>
      </div>
    )
  }
}

const mapStateToPropsGates = (state, props) => {
  return {
    hasNewEditor: makeHasGate('VISUAL_BOT_BUILDER')(state),
    killOneTimeEmailSends: killOneTimeEmailSends(state),
    playbookEditorLink: getPlaybookEditorLink(state, props.playbookData.playbook)
  }
}

export default connect(mapStateToPropsGates)(withRouter(PlaybookEditCell))



// WEBPACK FOOTER //
// ./src/scripts/components/PlaybookList/PlaybooksTableRow/PlaybookEditCell.js